<template>
  <div class="gallery-c669ebd7" resmed-component-name="gallery-c669ebd7">
    <div class="swiper">
      <div class="seek">
        <div class="seek-wrapper">
          <a
            ref="swiperButtonPrev"
            href="#"
            class="btn navigation-icon left-caret swiper-button-prev"
          ></a>
          <a
            ref="swiperButtonNext"
            href="#"
            class="btn navigation-icon right-caret swiper-button-next"
          ></a>
        </div>

        <div
          ref="swiperContainer"
          class="swiper-container"
          v-bind:class="`-mode-${[$root.mode]}`"
        >
          <div class="items swiper-wrapper">
            <div class="item swiper-slide" v-for="(item, index) in items">
              <figure>
                <img style="width: 100%" v-bind:src="item.sizes.large" alt="" />
              </figure>
            </div>
          </div>
        </div>
      </div>

      <div ref="swiperPagination" class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import helper from "../../mixins/swiper-helper";

export default {
  name: "gallery-c669ebd7", // gallery-c669ebd7
  props: ["items"],
  data() {
    return {
      slider: undefined,
      swiper: Math.random().toString(36).substr(2, 9),
    };
  },
  mixins: [helper],
  mounted() {
    this.$nextTick(() => this.swhReload());
  },
  methods: {
    swhCreate() {
      this.slider = new swiper(this.$refs.swiperContainer, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        freeMode: false,
        freeModeSticky: true,
        pagination: {
          el: this.$refs.swiperPagination,
          clickable: true,
        },
        navigation: {
          nextEl: this.$refs.swiperButtonNext,
          prevEl: this.$refs.swiperButtonPrev,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.gallery-c669ebd7 {
  overflow: hidden;

  .items {
    display: flex;
    align-items: stretch;
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .item {
    display: flex;
    flex-shrink: 0;
    align-items: stretch;

    // figure {
    //     width: 100%;
    // }
  }

  .swiper {
    position: relative;
  }

  .swiper-pagination {
    position: absolute;
    left: 50%;
    bottom: 1rem;
    transform: translateX(-50%);
  }

  .seek-wrapper {
    position: absolute;
    z-index: 2;
    width: 100%;
    padding: 0 1.25rem;
    top: 50%;
    transform: translateY(-50%);

    a {
      transform: scale(1.3);
    }

    a:nth-child(1) {
      float: left;
    }

    a:nth-child(2) {
      float: right;
    }
  }
}
</style>